import '../styles/index.scss';
import * as PIXI from 'pixi.js';
import TWEEN from '@tweenjs/tween.js';
import FontFaceObserver from 'fontfaceobserver';
import { startGame } from '@/scenes';
import { initMidi } from '@/input/midi';
import { initKeyboardControls } from '@/input/keyboard';
import { Keysound } from '@/audio/audio';
import { showVersionInfo } from '@/version'
import { EVENT_BUS } from '@/model/event-bus';
import { store } from '@/model/store';

async function preloadFonts() {
    return new FontFaceObserver('Bravura', {
        weight: 400
    }).load().then(function () {
        console.log('Font is available');
    }, function (err) {
        console.log('Font is not available', err);
    });
}

function initElectronBridge() {
    if (window.api) {
        console.log("We are running in electron mode", window.api)
    } else {
        console.log("We are running in browser mode")
        window.api = {
            send: () => {
                console.log('stub send')
            },
            receive: (from, callback) => {
                console.log('stub receive')
            }
        }
    }
   
}

async function run() {
    PIXI.Text.nextLineHeightBehavior = true;
    PIXI.Ticker.shared.add(()=>{
        TWEEN.update(performance.now());
    });
    initElectronBridge();
    await initMidi();
    await preloadFonts();
    const keySound = new Keysound();
    await keySound.load();
    initKeyboardControls();
    showVersionInfo();

    startGame();
    window.api.receive("fromMain", (data) => {
        console.log(`Received ${JSON.stringify(data)} from main process`);
        store.updateSettings(data);
    });
    window.api.send("toMain", "some data");
}

try {
    window.addEventListener("unhandledrejection", event => {
        if (event.reason && event.reason.toString().includes('RangeError')) {
            console.error(event);
        } else {
            // alert(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
            EVENT_BUS.emit('error', event.reason);
        }
      });
    run()
} catch (e) {
    alert(JSON.stringify(e, null, 2));
}